/* global window */
import React from 'react';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './AvatarDropdown.scss';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import { Avatar } from 'panamera-react-ui';
import AsyncMyAccount from 'Components/MyAccount/AsyncMyAccount';
import MyZoneDropdown from './my-zone-dropdown/AsyncMyZoneDropdown';
import { FormattedMessage as Translation } from 'react-intl';
import { connect } from 'react-redux';

import RedDot from '../../pages/MyZone/RedDot/RedDot';

export class AvatarDropdown extends React.PureComponent {
    static propTypes = {
        imageURl: PropTypes.string.isRequired,
        isMxCl: PropTypes.bool,
        isOtoplus: PropTypes.bool,
        userName: PropTypes.string,
        isMyZoneFinanceEnabled: PropTypes.bool,
        isMyZoneEnabled: PropTypes.bool.isRequired,
        threads: PropTypes.array.isRequired
    };

    constructor(props) {
        super(props);

        this.avatarElement = null;

        this.setAvatarElementRef = element => {
            this.avatarElement = element;
        };

        this.state = {
            showDropdown: false
        };
    }

    componentDidMount() {
        if (typeof document !== 'undefined') {
            document.addEventListener('click', this.handleClickOutside, true);
        }
    }

    componentWillUnmount() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('click', this.handleClickOutside, true);
        }
    }

    handleClickOutside = event => {
        const domNode = this.avatarElement;
        let timer;

        if (!domNode || !domNode.contains(event.target)) {
            timer = setTimeout(() => {
                this.closeDropdown();
                clearTimeout(timer);
            }, 0);
        }
    }

    closeDropdown = () => {
        this.setState({
            showDropdown: false
        });
    }

    toggleDropdown = () => {
        this.setState({
            showDropdown: !this.state.showDropdown
        });
    }

    getDropdownRightPosition() {
        if (!window || !this.avatarElement) {
            return 0;
        }

        return window.innerWidth - this.avatarElement.getBoundingClientRect().right;
    }

    render() {
        const { showDropdown } = this.state;
        const { isMxCl, isOtoplus, userName, isMyZoneEnabled, threads, isMyZoneFinanceEnabled } = this.props;
        const avatarClassName = isMxCl ? `${css.avatarContainer} ${css.mxclAvatar}` : css.avatarContainer;
        const hasThreads = threads.length > 0;

        return (
            <>
                <div
                    className={ avatarClassName }
                    data-aut-id="iconProfile"
                    onClick={ this.toggleDropdown }
                    ref={ this.setAvatarElementRef }
                >
                    {isMyZoneEnabled && <RedDot className={ css.redDotContainer } threads={ threads } /> }
                    {!isMxCl && <Avatar
                        diameter="35px"
                        className={ css.avatar }
                        image={ this.props.imageURl }
                    />
                    || <div className={ classNames(css.avatarInitials, { [css.avatarInitialsOtoplus]: isOtoplus }) } >{userName && userName[0].toUpperCase()}</div>
                    }
                    <Icon
                        icon="arrowDown"
                        size={ 20 }
                    />
                    { showDropdown
                        && ReactDOM.createPortal(<div className={ css.dropDownList } style={ { right: this.getDropdownRightPosition() } }>
                            <AsyncMyAccount isMxCl={ isMxCl } isMyZoneFinanceEnabled={ isMyZoneFinanceEnabled } selectFrom="header" />
                        </div>, document.body)
                    }
                </div>
                {isMxCl && isMyZoneEnabled ? <MyZoneDropdown hasThreads={ hasThreads } >
                    <Translation id="myZoneFeatureText" />
                </MyZoneDropdown> : null}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        isMyZoneEnabled: state.isMyZoneEnabled,
        threads: state.chat?.threads || []
    };
};

export default connect(mapStateToProps)(AvatarDropdown);
